<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Computer Engineering"
                   :links="[{title:'Home', url:'/'},{title:'Computer Engineering'}]"></page-header>

      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="1"></sidebar>
        </section>
        <section class="content">
          <div class="flex justify-center">
            <div class="flex flex-col space-y-1 items-center">
              <img class="shadow-lg" :src="`/static/images/computer/faculty/Chandgude_AS.jpg`"
                   alt="Head of Department of Computer Engineering">
              <h3 class="text-lg font-medium text-gray-800 leading-tight">Prof. Chandgude A. S.</h3>
              <h4 class="text-gray-500 font-medium leading-tight">Head of the Department</h4>
            </div>
          </div>
          <blockquote class="mt-3 about-message">
            <p>Department of Computer Engineering is a growing Department with the undying efforts and potential of 16
              Teaching and 4 Technical Staff members under the leadership of <strong>Prof. A. S. Chandgude (Head of
                Department)</strong>. The Department was established in the year 2007, offers programs in <strong>Bachelor
                Degree in
                Computer Engineering (B.E.) and Master Degree in Computer Engineering (M.E.)</strong>. These programs
              are
              approved by <strong>AICTE</strong> and affiliated to <strong>Savitribai Phule Pune University, (SPPU)
                Pune</strong>, with an intake of <strong>60
                in B.E.</strong> and <strong>18 in M.E.</strong></p>
            <p>We focus in imparting the core science underlying the computing aspects, so that students cope easily
              with today’s modern and upgrading technologies. We also strive to bridge the theory- practice gap by
              applying continuous effort in teaching, learning and by periodically measuring the outcomes. The
              department inculcates technical, analytical and communication skills in students that would suffice for
              any job in the current challenging world. The Department provides suitable environment that enables
              students to follow their instincts of learning and doing innovative things.</p>
            <p>The department has always been recognized for excellence in teaching and outstanding students’
              performance at global level and for the excellent placement record in various international/national
              companies. All over the world, the alumni of the department occupy top positions in IT industries like
              Infosys, TCS, Tech-Mahindra, Cisco, Cognizant, Autos Syntel, Wipro and many more.</p>
            <p>The style and method of imparting education to students make them self-capable for life-long learning and
              ready for diversified carriers in IT Industry, Education, Research, Management and Entrepreneurship.</p>
            <p>Research guidance to M.E. Students is provided by experienced faculty members in the areas like Networks
              Security, Cloud Computing, Data Mining and Knowledge Management, Soft Computing, Image Processing,
              Artificial Intelligence, Ad-hoc Networks, Parallel Processing, Software Engineering etc. The department
              also organizes National/International Conference, Workshops, Seminar, Expert Lectures in above mentioned
              areas.</p>
            <p>The Department has 10 nos. of state-of-the-art computer laboratories with latest computers and software
              supported by High Speed Ethernet and Wireless networks.</p>
            <signature name="Prof. Chandgude A. S." designation="Head of the Department"></signature>
          </blockquote>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/computer/Sidebar";
import KeyRecruiters from "@/components/KeyRecruiters";
import Signature from "@/components/Signature";

export default {
  name: "About",
  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    KeyRecruiters,
    Signature,
  },

}
</script>
<style lang="scss" scoped>
</style>
